import React from 'react';
import icon from '../../assets/images/bossy-icon.png';
import wordmark from '../../assets/images/bossy-logo.png';

interface BossyLogoProps {
  /** Tailwind height class that sizes the whole lockup, e.g. "h-8". */
  className?: string;
}

/**
 * App icon followed by the Bossy wordmark. The wordmark keeps the "Bossy Logo"
 * alt text; the icon is decorative.
 */
const BossyLogo: React.FC<BossyLogoProps> = ({ className = 'h-8' }) => (
  <span className={`inline-flex items-center ${className}`}>
    <img src={icon} alt="" aria-hidden="true" className="h-[76%] w-auto" />
    <img src={wordmark} alt="Bossy Logo" className="h-[90%] w-auto" />
  </span>
);

export default BossyLogo;
